module.exports = __webpack_public_path__ + "media/images/vp/parallax.new.03.b-ed37bb6d117d3715133b388e2c68d9dc.svg";